import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import HomePage from "./Page/HomePage/HomePage";
import Projects from "./Components/Projects/Projects";
import Contact_me from "./Components/Contact_me/Contact_me";
import Footer from "./Components/Footer/Footer";
import SocialAttachBar from "./Components/SocialAttachBar/SocialAttachBar";
import AboutMe from "./Components/Aboutme/AboutMe";
import Blog from "./Components/Blog/Blog";
import Navbar from "./Components/Navbar/Navbar";

function App() {
  return (
    <div>
      <Router>
        <Navbar />
        <Routes>
          <Route exact path="/" element={<HomePage />} />
          <Route exact path="/works" element={<Projects />} />
          <Route exact path="/Contacts_us" element={<Contact_me />} />
          <Route exact path="/about" element={<AboutMe />} />
          <Route exact path="/blog" element={<Blog />} />
        </Routes>
        <SocialAttachBar />
        <Footer />
      </Router>
    </div>
  );
}

export default App;
